<script lang="ts">
  import { createEventDispatcher, onMount } from "svelte";

  let isLoading = false;
  const dispatch = createEventDispatcher();
  let target: null | HTMLDivElement;
  const opts: IntersectionObserverInit = {
    rootMargin: "0px",
    threshold: 0.1,
  };
  const state$ = {
    loaded: () => {
      isLoading = false;
    },
    completed: () => {
      isLoading = false;
      observer.unobserve(target);
    },
  };
  const cb: IntersectionObserverCallback = (entries) => {
    if (entries[0].isIntersecting && !isLoading) {
      isLoading = true;
      dispatch("infinite", state$);
    }
  };
  const observer = new IntersectionObserver(cb, opts);
  onMount(() => {
    observer.observe(target);
  });
</script>

<div bind:this={target}></div>
